<template>
    <b-form-row>
        <b-col>
            <b-form-group label="Cardholder Id">
                <b-form-input v-model="patientPlan.cardholderId"></b-form-input>
            </b-form-group>
        </b-col>
        <b-col>
            <b-form-group label="Group Id">
                <b-form-input v-model="patientPlan.groupId"></b-form-input>
            </b-form-group>
        </b-col>
        <b-col>
            <b-form-group label="Person Code">
                <b-form-input v-model="patientPlan.personCode"></b-form-input>
            </b-form-group>
        </b-col>
        <b-col>
            <EnumSelector label="Relationship Code"
                          v-model="patientPlan.relationshipCode"
                          :enumCodes="relationshipCodes"></EnumSelector>
        </b-col>
    </b-form-row>
</template>

<script lang="ts">
    import Component from "vue-class-component";
    import {Vue, VModel} from "vue-property-decorator";
    import {PatientPlan, RelationshipCode} from "@/models/PatientPlan";
    import EnumSelector from "@/components/EnumSelector.vue";

    @Component({
        components: {
            EnumSelector,
        }
    })
    export default class PatientPlanEditComponent extends Vue {
        @VModel() private patientPlan!: PatientPlan;
        readonly relationshipCodes = RelationshipCode;

    }
</script>

<style scoped>
</style>
